<!--聊天交流  -->
<template>
  <div :class="['chat', disable ? 'disableChat' : '']">
    <!-- 聊天列表 -->
    <div class="chat-box">
      <ul v-if="selected === 0">
        <li v-for="(item, index) in allMsgList" :key="index">
          <span :class="item.type">{{ setName(item) }}：</span
          ><b class="txt"  :class="item.type" v-html="item.content"></b>
        </li>
      </ul>
      <ul v-else>
        <li v-for="(item, index) in officialList" :key="index">
          <span :class="item.type">{{ setName(item) }}：</span>
          <b class="txt" :class="item.type" v-html="item.content"></b>
        </li>
      </ul>
    </div>
    <footer :class="['foot', isAndroid && disable ? 'androidFoot' : '']">
      <div class="foot-box" v-if="!disable">
        <img
          v-if="recommendIconShow"
          @click="$emit('openRecommend')"
          class="recommendIcon"
          src="../../../assets/img/live/recommendIcon.gif"
          alt=""
        />
        <input
          class="input"
          placeholder="和大家一起讨论一下吧"
          v-model="msgVal"
          maxlength="50"
          type="text"
        />
        <button @click="sendMsg" class="send">{{ sendBtn }}</button>
      </div>
      <div class="disableBtn" v-else @click="toastShow">
        <p>和大家一起讨论一下吧</p>
      </div>
    </footer>
    <div v-show="toastStatus" class="toastStatus">请在竖屏模式发表讨论</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allMsgList: [], //所有聊天信息
      officialList: [], //官方聊天列表
      sendBtn: '发送', //发送弹幕按钮
      msgVal: '', //弹幕
      onlyLook: false, //仅看官方
      toastStatus: false,
      isAndroid: navigator.userAgent.match(/android/i), //处理在安卓机上的兼容问题(全屏时可点击 但不显示)
    };
  },
  props: {
    selected: {
      type: Number,
      default: 0,
    },
    disable: {
      type: Boolean,
      dafault: false,
    },
    recommendIconShow: {
      type: Boolean,
      default: false,
    },
    skuId: {
      type: Number,
      default: 0,
    },
    isCommentGroup: {
      //是否开启分组
      type: Number,
      default: 0,
    },
  },
  watch: {
    disable() {
      this.chatHeight();
    },
    selected() {
      this.chatHeight();
    },
  },
  components: {},

  computed: {},
  created() {},
  mounted() {
    DWLive.onPublicChatMessage = (data) => {
      const t = JSON.parse(data);
      console.log(t, 88899);
      if (this.isCommentGroup === 0 || t.groupId == this.skuId || !t.groupId) {
        if(t.status==1)return;
        if (t.isFilterChat && t.isFilterChat === 1) return;
        this.allMsgList.push({
          type: t.userrole,
          name: t.username,
          content: this.changeEmImg(t),
        });
        if (t.userrole === 'host' || t.userrole === 'teacher' || t.userrole === 'publisher')
          this.officialList.push({
            type: t.userrole,
            name: t.username,
            content: this.changeEmImg(t),
          });
        // 每十条算一次高度 防止最后进入直播间 聊天过多 卡死页面
        if (this.selected === 0) {
          if (this.allMsgList.length % 5 === 0) this.chatHeight();
        } else {
          if (this.officialList.length % 5 === 0) this.chatHeight();
        }
      }
    };

    DWLive.onBroadcastMsg = (data) => {
      const temp={
        type: 'system',
        name: '系统消息',
        content: data.content,
      }
      this.allMsgList.push(temp);
      this.officialList.push(temp);
      console.log(data, 9999, this.allMsgList);
    };
  },

  methods: {
    //接收聊天数据
    receiveChat() {},
    //设置发言人名称
    setName(item) {
      //host:主持人 teacher:助教 publisher:讲师
      let name = item.name;
      if (item.type === 'publisher') {
        name = '讲师';
      } else if (item.type === 'teacher') {
        name = '助教';
      } else if (item.type === 'host') {
        name = '主持人';
      } else if (item.type === 'system') {
        name = '系统消息';
      } else {
        if (/^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(name)) {
          name = name.substr(0, 3) + '****' + name.substr(7);
        }
      }
      return name;
    },
    //聊天内容处理
    changeEmImg(t) {
      let msg = '',
        str = t.msg;
      if (str.indexOf('[img_') > -1) {
        //图片处理
        let url = str.split('[img_')[1].replace(']', '');
        let w = '300px',
          h;
        if (url.indexOf('w=') > -1) w = url.split('w=')[1].split('&h=')[0];
        if (url.indexOf('h=') > -1) h = url.split('h=')[1];
        const winW = window.innerWidth;
        if (w >= winW) {
          w = '100%';
        } else {
          w = (w / winW) * 100 + '%';
        }
        // if (w > 360) w = '360px';
        msg = `<img src=${url} style="width: ${w}; height: ${h}; vertical-align: middle"/>`;
      } else if (str.indexOf('[em2_') > -1) {
        msg = str.replace(
          /\[em2_([0-9]*)\]/g,
          `<img src="http://view.csslcloud.net/img/em2/$1.png" width="16" height="16" style="vertical-align: middle; transform: translateY(-2px);margin-left: 2px"/>`,
        );
      } else {
        str = str.replace(/\</g, '&lt;');
        str = str.replace(/\>/g, '&gt;');
        str = str.replace(/\n/g, '<br/>');
        $.each(str.split(' '), (i, n) => {
          n = $.trim(n);
          if (n.indexOf('[uri_') == 0 && n.indexOf(']') == n.length - 1 && n.length > 6) {
            var u = n.substring(5, n.length - 1) + ' ';
            msg += '<a target="_blank" style="color: #0091FF" href="' + u + '">' + u + '</a>' + ' ';
          } else {
            if (t.userrole === 'student') {
              msg += n + ' ';
            } else {
              msg += this.ReplaceUrl(n) + ' ';
            }
          }
        });
      }
      return msg;
    },
    ReplaceUrl(text) {
      let re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi;
      let s = text.replace(re, (u) => {
        return `<a target="_blank" style="color: #0091FF" href="${u}" target=_blank>${u}</a>`;
      });
      return s;
    },
    //发送聊天
    sendMsg() {
      const { msgVal, sendBtn } = this;
      if (!msgVal.trim() || sendBtn !== '发送') return;
      //发送弹幕逻辑。。。
      DWLive.sendPublicChatMsg(msgVal.trim()); // 发送公聊
      this.msgVal = '';
      this.sendBtn = 2;
      this.timer = setInterval(() => {
        this.sendBtn -= 1;
        if (this.sendBtn < 1) {
          this.sendBtn = '发送';
          clearInterval(this.timer);
        }
      }, 1000);
      this.chatHeight();
    },
    chatHeight() {
      //重新计算当前聊天高度
      setTimeout(() => {
        if (this.disable) {
          //全屏时
          $('.chat-box').scrollTop($('.chat-box ul').height());
        } else {
          //竖屏时
          $('.tab-content').scrollTop($('.chat').height());
        }
      });
    },
    toastShow() {
      this.toastStatus = true;
      setTimeout(() => {
        this.toastStatus = false;
      }, 1500);
    },
  },
};
</script>
<style lang="scss" scoped>
.chat-box {
  width: 100%;
  padding-bottom: 170px;
  ul {
    width: 100%;
    padding: 24px 40px;
    li {
      padding-bottom: 24px;
      .host {
        color: #337ade;
        font-size: 28px;
      }
      .publisher {
        color: #3eccc7;
        font-size: 28px;
      }
      .system {
        color: #6B64E0;
        font-size: 28px;
      }
      .teacher {
        color: #FFAD1E;
        font-size: 28px;
      }
      .student {
        color: #FF7F41;
        font-size: 28px;
      }
      .txt {
        color: #787878 ;
        font-weight: normal;
        font-size: 28px;
        word-break: break-all;
      }
      .txt.system{
        color: #FF7F41 !important;
      }
    }
  }
}
.foot {
  position: fixed;
  bottom: 100px;
  left: 0;
  z-index: 105;
  width: 100%;
  height: 98px;
  background: #fff;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);

  .foot-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 98px;
    padding: 0 40px;
    .recommendIcon {
      width: 90px;
      height: 90px;
    }
    .input {
      width: 518px;
      height: 70px;
      margin-right: 10px;
      padding: 0 0 0 20px;
      color: 3787878;
      font-size: 28px;
      background: #f9f9f9;
      border-radius: 35px;
    }
    .send {
      width: 206px;
      height: 70px;
      color: #fff;
      font-size: 28px;
      line-height: 70px;
      text-align: center;
      background: #ff6c02;
      border-radius: 35px;
    }
  }
}
.toastStatus {
  position: fixed;
  top: 20%;
  left: 50%;
  width: 270px;
  height: 60px;
  color: #fff;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  transform: translate(-50%, -50%);
}
.disableChat {
  height: 100%;
  padding-bottom: calc(100vw * 0.12);
  overflow: hidden;
  .chat-box {
    height: 100%;
    padding-bottom: 0;
    overflow-x: scroll;
    ul {
      padding: 25px;
      li {
        line-height: 30px;
      }
    }
  }
  .foot {
    position: absolute;
    right: 0;
    bottom: 0;
    left: initial;
    .disableBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      height: 60%;
      margin: 15px auto 0;
      color: #a5a5a5;
      font-size: 18px;
      background: #fafafa;
      border-radius: 30px;
    }
  }
  .androidFoot {
    position: fixed;
    width: 25%;
  }
}
</style>
